import styled from 'styled-components';
import { Link } from 'react-router-dom';

const linkStyles = `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  cursor: pointer;
  text-decoration: none;
  opacity: 0.85;
  transition: opacity 0.2s;
  min-height: 0;

  &:hover {
    opacity: 1;
  }
`;

export const LinkStyled = styled(Link)`
  ${linkStyles}
`;

export const LinkStyledAsAnchor = styled.a`
  ${linkStyles}
`;

/** Размеры: whiteswan default/alternate, blackswan default/alternate */
const logoImgWidth = (p) => {
  if (p.$brand === 'blackswan') return p.$small ? '90px' : '147px';
  return p.$small ? '100px' : '147px';
};
const logoImgMaxHeight = (p) => {
  if (p.$brand === 'blackswan') return p.$small ? '14px' : '22px';
  return p.$small ? '16px' : '22px';
};

export const LogoImg = styled.img`
  display: block;
  flex-shrink: 0;
  height: auto;
  width: ${logoImgWidth};
  max-height: ${logoImgMaxHeight};
  object-fit: contain;
`;

/** whiteswan: default 20px, alternate 14px. blackswan: default 20px, alternate 13px */
const textFontSize = (p) => {
  if (p.$brand === 'blackswan') return p.$small ? '12px' : '18px';
  if (p.$small) return '14px';
  return '20px';
};

export const Text = styled.span`
  font-size: ${textFontSize};
  line-height: 1.2;
  color: ${(p) => (p.$theme === 'light' ? '#ffffff' : '#000000')};
  font-family: 'Montserrat', Arial, sans-serif;
  font-weight: 600;
`;
